


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { IBarChartData } from '@/interfaces'
import { UserModule } from '@/store/modules/user.module'
import Avatar from '@/components/Avatar.vue'
import ScrollView from '@/components/ScrollView.vue'
import OnboardingMilestoneStatistics from './components/OnboardingMilestoneStatistics.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import AdminUsersPanel from './components/AdminUsersPanel.vue'
import Icon from '@/components/Icon.vue'
import BillingStatistics from './components/BillingStatistics.vue'
import ClientsByModulesStatistics from './components/ClientsByModuleStatistics.vue'
import RevenueByModulesStatistics from './components/RevenueByModuleStatistics.vue'
import ChainsStatistics from './components/ChainsStatistics.vue'
import FacilitiesStatistics from './components/FacilitiesStatistics.vue'
import SalesRepsPanel from './components/SalesRepsPanel.vue'
import Input from '@/components/inputs/Input.vue'

@Component({
  components: {
    Input,
    Card,
    Icon,
    BarChart,
    BillingStatistics,
    AdminUsersPanel,
    Avatar,
    ScrollView,
    LoaderWrapper,
    OnboardingMilestoneStatistics,
    ClientsByModulesStatistics,
    RevenueByModulesStatistics,
    ChainsStatistics,
    FacilitiesStatistics,
    SalesRepsPanel
  }
})
export default class AdminDashboard extends Vue {
  userInstanceModule: UserModule = getModule(UserModule, this.$store);
  alertsData: IBarChartData[] = [];
  tasksData: IBarChartData[] = [];
  isLoading: boolean = true;
  password: string = '';
  showSecured: boolean = false;
  get dashboardData () {
    return this.$store.state.user.dashboardData
  }

  get dashboardStatistic () {
    return this.$store.state.user.dashboardStatistic
  }

  checkPassword () {
    if ([
      '12234',
      '33453',
      '45632',
      '32443',
      '13412'
    ].includes(this.password)) {
      this.showSecured = true
    }
  }

  async mounted () {
    await this.userInstanceModule.fetchUsersDashboardData()
    this.isLoading = false
    this.initAlertsChart()
    this.initTasksChart()
  }

  initAlertsChart () {
    this.alertsData = []
    this.alertsData.push({
      title: 'Due',
      items: [{
        value: this.dashboardStatistic.alerts.due,
        color: '#FFBE0B',
        label: 'Due:'
      }]
    })
    this.alertsData.push({
      title: 'Overdue',
      items: [{
        value: this.dashboardStatistic.alerts.overdue,
        color: '#FFBE0B',
        label: 'Overdue:'
      }]
    })
    this.alertsData.push({
      title: 'Done this week',
      items: [{
        value: this.dashboardStatistic.alerts.completed,
        color: '#FFBE0B',
        label: 'Done:'
      }]
    })
  }
  initTasksChart () {
    this.tasksData = []
    this.tasksData.push({
      title: 'Due',
      items: [{
        value: this.dashboardStatistic.tasks.due,
        color: '#9966FF',
        label: 'Due:'
      }]
    })
    this.tasksData.push({
      title: 'Overdue',
      items: [{
        value: this.dashboardStatistic.tasks.overdue,
        color: '#9966FF',
        label: 'Overdue:'
      }]
    })
    this.tasksData.push({
      title: 'Done this week',
      items: [{
        value: this.dashboardStatistic.tasks.completed,
        color: '#9966FF',
        label: 'Done:'
      }]
    })
  }
}
